module.exports = __webpack_public_path__ + "img/bg02.4c44a367.png";